import React, { useState } from 'react';
import * as R from 'ramda';
import { css } from '@emotion/react';
import * as Yup from 'yup';
import { loadDataHOC } from '../hoc';
import { accountObject, clientPhoneObject } from '../lib/utils/schema';
import {
	DropDownRHF,
	MaskedInputRHF,
	FormGroupRHF,
	FormCardRHF,
	BaseRHF,
	InputRHF
} from '@cd/rhf';

import useUpdateAccount from './fetch/useUpdateAccount';

const AccountSchema = Yup.object().shape(
	R.compose(
		R.mergeLeft(clientPhoneObject),
		R.omit(['token', 'password'])
	)(accountObject)
);

const oneLineStyle = css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between'
});
const oneLine2Style = css({
	display: 'flex',
	alignItems: 'center',
	'& > *:first-child': { marginRight: '16px' }
});

const loadDataForAccount = loadDataHOC('GET', '/account/get/info', {
	reactQuery: { queryName: 'getAccountInfo' }
});

const Account = ({ data: [titles, data] }) => {
	const record = (data && data[0]) || {
		title: '',
		email: '',
		phone: '',
		first_name: '',
		last_name: ''
	};
	const [showOtherTitle, setShowOtherTitle] = useState(false);

	const { mutate } = useUpdateAccount();

	return (
		<FormCardRHF
			mode="all"
			onHandleChange={({ title }) => setShowOtherTitle(title === 4020)}
			onSubmit={(values, formFns) => mutate(values, formFns)}
			schema={AccountSchema}
			title="Account information"
			subtitle="Update your account info"
			okButtonTitle="UPDATE"
			defaultValues={record}>
			<FormGroupRHF style={oneLineStyle} name="memberInfo">
				<BaseRHF
					render={props => (
						<MaskedInputRHF
							{...props}
							label="Email"
							mask={/^\S*@?\S*$/}
						/>
					)}
					margin="normal"
					name="email"
					label="Email"
				/>

				<BaseRHF
					render={props => (
						<DropDownRHF
							{...props}
							options={titles}
							name="title"
							label="Title"
						/>
					)}
					id="title"
					margin="normal"
					name="title"
					label="Title"
				/>
			</FormGroupRHF>
			<FormGroupRHF
				style={oneLineStyle}
				name="memberInfo"
				hidden={!showOtherTitle}>
				<InputRHF
					margin="normal"
					label="Title Name"
					name="title_name"
				/>
			</FormGroupRHF>
			<FormGroupRHF style={oneLine2Style} name="memberName">
				<InputRHF
					margin="normal"
					name="first_name"
					label="First Name"
				/>
				<InputRHF margin="normal" name="last_name" label="Last Name" />
			</FormGroupRHF>
			<BaseRHF
				render={props => (
					<MaskedInputRHF
						{...props}
						label="Phone"
						mask="(000)000-0000"
					/>
				)}
				margin="normal"
				name="phone"
				label="Phone"
			/>
		</FormCardRHF>
	);
};

export default loadDataForAccount(Account);
